import { Button } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import DeleteReportModal from '../../../components/DeleteReportModal/DeleteReportModal';
import styles from '../index.css';

type Props = {
    activeReportData: ReportDataItem;
    reportType: ReportType;
};

const DeleteReport = ({ activeReportData, reportType }: Props) => {
    const { t } = useTranslation();
    const [deleteReportIsOpen, setDeleteReportIsOpen] = useState(false);
    const history = useHistory();

    return (
        <>
            <Button
                className={styles.deleteReportBtn}
                variant='secondary'
                size='small'
                data-testid='delete-btn'
                onClick={handleOnClickEvent(() => setDeleteReportIsOpen(true))}
                onKeyDown={handleKeyEvent(() => setDeleteReportIsOpen(true))}
            >
                {t('Delete Report')}
            </Button>
            <DeleteReportModal
                isOpen={deleteReportIsOpen}
                onClose={() => setDeleteReportIsOpen(false)}
                rowValues={{
                    id: activeReportData?.id!,
                    name: activeReportData?.properties?.name,
                    createdAt: activeReportData?.createdAt,
                    createdBy: activeReportData?.createdBy,
                    source: 'window'
                }}
                onSuccess={() => history.push(`/reports?reportType=${reportType}`)}
                reportType={reportType}
            />
        </>
    );
};

export default DeleteReport;
